'use client'

import { OutputData } from '@editorjs/editorjs'
import clsx from 'clsx'
import React, { useState } from 'react'

import { ZEditorJsRenderer } from '@/_components/universal/editorjs-renderer'

import { hasValidContentBlocks } from '../../utils/content.utils'

interface IProps {
	title: string
	content: OutputData
	defaultExpanded?: boolean
}

export default function AAmbulanceContentItem({ title, content, defaultExpanded = false }: IProps) {
	if (!hasValidContentBlocks(content)) {
		return null
	}

	const [isExpanded, setIsExpanded] = useState(defaultExpanded)

	return (
		<div className={clsx('item_accord under accorditem', { expanded: isExpanded })}>
			<p className='item_accord_head accordhead' onClick={() => setIsExpanded(prev => !prev)}>
				<span>{title}</span>
				<svg className='sico'>
					<use href='/assets/layout/icons.svg#s_ar1_d'></use>
				</svg>
			</p>

			<div className='item_accord_expand'>
				<div>
					<div className='item_accord_content'>
						<div className='page_content reset_margins text_s16 nobalance mgt-15lg pdr-10lg '>
							<ZEditorJsRenderer data={content} className='!pb-0' />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
